import React, { createContext, useContext } from 'react';
import { useAuth } from '../providers/AuthProvider';
import axios from 'axios';

const ApiBessContext = createContext();

export const ApiBessProvider = ({ children }) => {
  const { user, logout } = useAuth();

  const API_URL = 'https://khg7takfya.execute-api.us-west-1.amazonaws.com'

  const get = async (url, params) => {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.credentials.AccessToken}`,
    }        
    let data = null;
    await axios.get(url, {
      headers: headers,
      params: params,
    })
    .then( (response) => {
      // console.log('Response:', response.data);
      data = response.data;
    })
    .catch ( (error) => {
      console.error('Error:', error);
      const statusCode = error.response.status;
      console.log('Error Status Code:', statusCode);
      if (statusCode === 401)
      {
        logout();
      }
    })
    .finally( () => {
    })
    return data;
  }

  const post = async (url, body=null) => {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.credentials.AccessToken}`,
    }        
    let data = null;

    await axios.post(url, body, {
      headers: headers,
    })
    .then( (response) => {
      // console.log('Response:', response.data);
      data = response.data;
    })
    .catch ( (error) => {
      console.error('Error:', error);
      const statusCode = error.response.status;
      console.log('Error Status Code:', statusCode);
      if (statusCode === 401)
      {
        logout();
      }
    })
    .finally( () => {
    })
    return data;
  }

  const getAvailableClusters = async () => {
    // console.log("Start querying get available clusters...");

    const url = API_URL + '/available';
    const params = {
      // user_id: user.email,
    };

    const response = await get(url, params);
    // console.log(response);
    if (response && response.data.available_clusters)
    {
      return response.data.available_clusters;
    }
    return [];
  }

  const getOverviewData = async (clusterId) => {
    // console.log("Start querying get cluster overview...");

    const url = API_URL + '/overview';
    const params = {
      cluster_id: clusterId,
      version: 2,
    };

    const response = await get(url, params);
    // console.log(response);
    if (response && response.data.cluster_info)
    {
      return response.data.cluster_info;
    }
    return [];
  }

  const getGridData = async (clusterId) => {
    // console.log("Start querying get cluster grid data...");

    const url = API_URL + '/grid';
    const params = {
      cluster_id: clusterId,
      version: 2,
    };

    const response = await get(url, params);
    // console.log(response);
    if (response && response.data.cluster_info)
    {
      return response.data.cluster_info;
    }
    return [];
  }

  const getSolarData = async (clusterId) => {
    // console.log("Start querying get cluster solar data...");
    const url = API_URL + '/solar';
    const params = {
      cluster_id: clusterId,
      version: 2,
    };
    const response = await get(url, params);
    // console.log(response);
    if (response && response.data.cluster_info)
    {
      return response.data.cluster_info;
    }
    return [];
  }

  const getBatteryData = async (clusterId) => {
    // console.log("Start querying get cluster grid data...");

    const url = API_URL + '/battery';
    const params = {
      cluster_id: clusterId,
      version: 2,
    };

    const response = await get(url, params);
    // console.log(response);
    if (response && response.data.cluster_info)
    {
      return response.data.cluster_info;
    }
    return [];
  }

  const getPcsData = async (clusterId) => {
    // console.log("Start querying get cluster grid data...");

    const url = API_URL + '/pcs';
    const params = {
      cluster_id: clusterId,
      version: 2,
    };

    const response = await get(url, params);
    // console.log(response);
    if (response && response.data.cluster_info)
    {
      return response.data.cluster_info;
    }
    return [];
  }

  const getComponentsTree = async (clusterId) => {
    // console.log("Start querying get cluster grid data...");

    const url = API_URL + '/get_components_tree';
    const params = {
      cluster_id: clusterId,
      version: 2,
    };

    const response = await get(url, params);
    // console.log(response);
    if (response && response.data && response.data.available_clusters && response.data.available_clusters.length > 0)
    {
      return response.data.available_clusters[0];
    }
    return [];
  }

  const getUtilityBillData = async (clusterId, year, month) => {
    const url = API_URL + '/utility_bill';
    const params = {
      cluster_id: clusterId,
      version: 2,
      year: year,
      month: month,
    };
    const response = await get(url, params);
    if (response && response.data.utility_bill) {
      return response.data.utility_bill;
    }
    return [];
  }

  const getUtilityBillPeriods = async (clusterId) => {
    const url = API_URL + '/utility_bill_periods';
    const params = {
      cluster_id: clusterId,
      version: 2,
    };
    const response = await get(url, params);
    if (response && response.data.utility_bill_periods) {
      return response.data.utility_bill_periods;
    }
    return [];
  }

  return (
    <ApiBessContext.Provider
      value={{
        getAvailableClusters,
        getOverviewData,
        getGridData,
        getSolarData,
        getBatteryData,
        getPcsData,
        getComponentsTree,
        getUtilityBillData,
        getUtilityBillPeriods,
      }}
    >
      {children}
    </ApiBessContext.Provider>
  );
};

export const useApiBess = () => useContext(ApiBessContext);